import React, {Component} from 'react';
import './index.css'
import { BsyUtils } from '../../utils/Utils';
import PubSub from "pubsub-js";

class LoginPasswordLevel extends Component {
    state={
        pwdLevel:window.data_config.pwdLevel,
        lvNum1:false,
        lvNum2:false,
        lvNum3:false,
        lvNum4:false,
        lvNum5:false,
        lvNum6:false,
        passValue : false
    }
    componentDidMount() {
        this.props.getIsPass && this.props.getIsPass(this)
    }
    subFunc(topic,value) {
        const regString = /^(?=.*?[A-Z]).*$/;
        const regString2 = /^(?=.*?[a-z]).*$/;
        const regString3 = /^(?=.*?[0-9]).*$/;
        const val = BsyUtils.isString(value) ? value : value.value;
        let ln=true;
        if(window.data_config.pwdLevel === "1"){
            if(val.length>=6 && val.length<=18){
                this.setState({lvNum1:true})
            }else{
                ln = false;
            }
        }else if(window.data_config.pwdLevel === "2"){
            if(val.length>=8 && val.length<=18){
                this.setState({lvNum2:true})
                if(regString2.test(val) || regString.test(val)){
                    this.setState({lvNum6:true})
                }else{
                    ln = false;
                    this.setState({lvNum6:false})
                }

                if(regString3.test(val)){
                    this.setState({lvNum3:true})
                }else{
                    ln = false;
                    this.setState({lvNum3:false})
                }
            }else{
                ln = false;
            }
        }else if(window.data_config.pwdLevel === "3"){
            if(val.length>=8 && val.length<=18){
                this.setState({lvNum2:true})
                if(regString.test(val)){
                    this.setState({lvNum5:true})
                }else{
                    ln = false
                    this.setState({lvNum5:false})
                }

                if(regString2.test(val)){
                    this.setState({lvNum4:true})
                }else{
                    ln = false
                    this.setState({lvNum4:false})
                }

                if(regString3.test(val)){
                    this.setState({lvNum3:true})
                }else{
                    ln = false
                    this.setState({lvNum3:false})
                }
            }else{
                ln = false;
            }
        }
        PubSub.publish('levelPass',{value:ln});
        this.setState({
            passValue : ln
        })
    }
    constructor(props) {
        super(props);
        const _this = this;
        this.pubsub_token=PubSub.subscribe("levelValue",(topic,value)=>{
            const regString = /^(?=.*?[A-Z]).*$/;
            const regString2 = /^(?=.*?[a-z]).*$/;
            const regString3 = /^(?=.*?[0-9]).*$/;
            const val = BsyUtils.isString(value) ? value : value.value;
            let ln=true;
            if(_this.state.pwdLevel === "1"){
                if(val.length>=6 && val.length<=18){
                    _this.setState({lvNum1:true})
                }else{
                    ln = false;
                }
            }else if(_this.state.pwdLevel === "2"){
                if(val.length>=8 && val.length<=18){
                    _this.setState({lvNum2:true})
                    if(regString2.test(val) || regString.test(val)){
                        _this.setState({lvNum6:true})
                    }else{
                        ln = false;
                        _this.setState({lvNum6:false})
                    }

                    if(regString3.test(val)){
                        _this.setState({lvNum3:true})
                    }else{
                        ln = false;
                        _this.setState({lvNum3:false})
                    }
                }else{
                    ln = false;
                }
            }else if(_this.state.pwdLevel === "3"){
                if(val.length>=8 && val.length<=18){
                    _this.setState({lvNum2:true})
                    if(regString.test(val)){
                        _this.setState({lvNum5:true})
                    }else{
                        ln = false
                        _this.setState({lvNum5:false})
                    }

                    if(regString2.test(val)){
                        _this.setState({lvNum4:true})
                    }else{
                        ln = false
                        _this.setState({lvNum4:false})
                    }

                    if(regString3.test(val)){
                        _this.setState({lvNum3:true})
                    }else{
                        ln = false
                        _this.setState({lvNum3:false})
                    }
                }else{
                    ln = false;
                }
            }
            PubSub.publish('levelPass',{value:ln});
            _this.setState({
                passValue : ln
            })
        });
        this.subFunc("levelValue", props.password)
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this.pubsub_token);
    }

    render() {
        const {pwdLevel, lvNum1, lvNum2, lvNum3, lvNum4, lvNum5, lvNum6} = this.state;
        return (
            <div className="LoginPasswordLevel">
                {(pwdLevel === "1" || pwdLevel === "2" || pwdLevel === "3") && <div className="verifyCont">
                    {pwdLevel === "1" && <div className="verifyItem one"><i className={lvNum1 ? "icon-success-print":"icon-dingding-guide-errorTip"} /><span>密码长度：6-18位</span></div>}
                    {(pwdLevel === "2" || pwdLevel === "3") && <div className="verifyItem two"><i className={lvNum2 ? "icon-success-print":"icon-dingding-guide-errorTip"}/><span>密码长度：8-18位</span></div>}
                    {(pwdLevel === "2" || pwdLevel === "3") && <div className="verifyItem three"><i className={lvNum3 ? "icon-success-print":"icon-dingding-guide-errorTip"}/><span>密码至少含有：1个数字</span></div>}
                    {pwdLevel === "3" && <div className="verifyItem four"><i className={lvNum4 ? "icon-success-print":"icon-dingding-guide-errorTip"} /><span>密码至少含有：1个小写字母</span></div>}
                    {pwdLevel === "3" && <div className="verifyItem five"><i className={lvNum5 ? "icon-success-print":"icon-dingding-guide-errorTip"}/><span>密码至少含有：1个大写字母</span></div>}
                    {(pwdLevel === "2") && <div className="verifyItem six"><i className={lvNum6 ? "icon-success-print":"icon-dingding-guide-errorTip"}/><span>密码至少含有：1个字母</span></div>}
                </div>}
            </div>
        );
    }
}

export default LoginPasswordLevel;